import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

export const AuthCallback: React.FC = () => {
  const { user, loading } = useAuth();

  useEffect(() => {
    // Wait for auth to finish loading, then redirect
    if (!loading) {
      // Use replace instead of href to avoid page reload
      window.history.replaceState({}, '', '/');
      
      // Force a page reload to ensure the main app loads correctly
      window.location.reload();
    }
  }, [loading]);

  return (
    <div className="min-h-screen bg-gray-950 text-white flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <h2 className="text-2xl font-bold mb-2">Completing Sign In...</h2>
        <p className="text-gray-400">Redirecting you to the homepage...</p>
      </div>
    </div>
  );
}; 